import React, { Component, Fragment } from "react";
import autoBind from "react-autobind";

import playerStore from "lib/player_store";
import { observer } from "mobx-react"; //disposeOnUnmount

import CircularSlider from "@fseehawer/react-circular-slider";
import { Popover, Divider, ClickAwayListener } from "@material-ui/core";
import { disableScroll, enableScroll } from "lib/util";
import { postJSON } from "lib/ajax";
const VARIETY_VALUES = [33, 66, 100];

const VarietySlider = observer(
  class VarietySlider extends Component {
    store = playerStore;

    constructor(props) {
      super(props);
      this.state = { isOpen: false, _value: null };
      this.submitting = null;
      autoBind(this);
    }
    // called on mount?
    setValue(v) {
      if (this.state._value === null) {
        //  console.log("initial variety setValue:", v);
        this.setState({ _value: v });
        return;
      }
      // console.log(
      //   "variety setValue: this.state._value",
      //   this.state._value,
      //   "v:",
      //   v
      // );

      if (this.store.mdc100 === v) {
        // console.log("variety setValue: same");
        return;
      }

      // console.log("variety setValue:", v);
      this.setState({
        _value: v,
      });

      // this.store.set_mdc100(v);
      clearTimeout(this.submitting);
      this.submitting = setTimeout(() => {
        this.submitValue();
      }, 700);
    }

    submitValue() {
      const v = this.state._value;
      if (v && parseInt(v) >= 1 && parseInt(v) <= 100) {
        postJSON({ url: "/players/mdc", data: { mdc100: v, only: 1 } }).then(
          () => {
            this.store.set_mdc100(v);

            //    console.log("variety updated");
            this.handleOpen();
          }
        );
      } else {
        //   console.log("not submitting variety:", v);
      }
    }

    handleClose() {
    //  console.log("");
      this.setState({ isOpen: false });
      enableScroll();
      clearTimeout(this.timeout);
    }

    handleOpen() {
      this.setState({ isOpen: true });
      disableScroll();
      this.timeout = setTimeout(() => {
        this.handleClose();
      }, 3500);
    }

    render() {
      const { isOpen } = this.state;
      const { knobColor } = this.props; //array
      // const kColor = knobColor ? knobColor : "230,230,230";
      const pColorTo = knobColor ? `rgb(${knobColor})` : "rgba(0,0,0,0.2)";

      const settingMessageContent = (
        <div className="p-2">
          <div className="p-2">
            <strong>{this.store.mdc_str}</strong>
          </div>
          <Divider />
          <div className="p-2">Setting Saved.</div>
        </div>
      );

      let knob;
      if (this.store.mdc === null) {
        knob = null;
      } else {
        knob = (
          <Fragment>
            <Popover
              disableScrollLock={true}
              open={Boolean(isOpen)}
              anchorEl={document.querySelector("#variety_knob")}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <ClickAwayListener onClickAway={this.handleClose}>
                {settingMessageContent}
              </ClickAwayListener>
            </Popover>
            <div id="variety_module">
              <div id="variety_knob">
                <CircularSlider
                  progressColorFrom="rgba(255,255,255,1)"
                  progressColorTo={pColorTo}
                  width={95}
                  labelFontSize="0.8rem"
                  label="VARIETY"
                  labelColor="#0C4675"
                  labelBottom={true}
                  appendToValue="%"
                  valueFontSize="1.6rem"
                  knobSize={42}
                  knobColor={`rgb(${knobColor})`}
                  direction={1}
                  progressSize={1}
                  trackSize={1}
                  trackColor="rgba(0,0,0,0.1)"
                  progressLineCap="flat"
                  min={1}
                  max={100}
                  // data={VARIETY_VALUES}
                  dataIndex={this.store.mdc100 - 1}
                  onChange={(v) => this.setValue(v)}
                ></CircularSlider>
              </div>

              {/* <div id="variety_module_label">Select Variety</div> */}
            </div>
          </Fragment>
        );
      }

      return knob;
    }
  }
);
export default VarietySlider;
